import { TRUST_LOGOS } from "@/data/content";

export default function TrustBadges() {
  // Duplicate for seamless marquee
  const items = [...TRUST_LOGOS, ...TRUST_LOGOS];
  return (
    <section
      data-testid="trust-badges"
      className="py-16 px-6 lg:px-12 border-y border-neutral-200/70"
    >
      <div className="max-w-[1400px] mx-auto">
        <p className="overline text-center mb-10">Trusted by founders at</p>
        <div className="marquee">
          <div className="marquee-track">
            {items.map((label, i) => (
              <span
                key={`a-${i}-${label}`}
                className="font-serif italic text-2xl md:text-3xl text-neutral-400 hover:text-gold transition whitespace-nowrap tracking-wide"
              >
                {label}
              </span>
            ))}
          </div>
          <div className="marquee-track" aria-hidden="true">
            {items.map((label, i) => (
              <span
                key={`b-${i}-${label}`}
                className="font-serif italic text-2xl md:text-3xl text-neutral-400 whitespace-nowrap tracking-wide"
              >
                {label}
              </span>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
